import React from "react"

export default function () {
  return <hr className="[ separator separator-light ]" />
}
